export const getProductID = (device) => {
	if (!device) {
		return null;
	}

	return device.Product || device.product || device.ProductID || device.productID || device.productid || device.ProductId || device.productId;
};

export const getDeviceProductLabel = (serialNumber, devices) => {
	const currentDevice = String(serialNumber || "").toUpperCase();
	const deviceList = Array.isArray(devices) ? devices : [];
	const matchedDevice = deviceList.find(device => String(device.SerialNumber).toUpperCase() === currentDevice);
	const productID = String(getProductID(matchedDevice) || "");

	if (productID === "2" || currentDevice.startsWith("RJ")) {
		return "Nova";
	} else if (productID === "3") {
		return "VISION";
	}

	return "EVO";
};

export const getDevicePageTitle = (serialNumber, pageTitle, devices) => {
	return getDeviceProductLabel(serialNumber, devices)+" "+pageTitle;
};

export const isNovaDevice = (serialNumber, devices) => {
	return getDeviceProductLabel(serialNumber, devices) === "Nova";
};
